import { render, staticRenderFns } from "./ApprovalItemList.vue?vue&type=template&id=20272aae&"
import script from "./ApprovalItemList.vue?vue&type=script&lang=js&"
export * from "./ApprovalItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports